<template>
  <button
    type="button"
    :disabled="props.disabled"
    class="-mx-1.5 -my-1 flex items-center gap-1 rounded-md px-1.5 py-1 outline-2 transition focus-visible:outline disabled:pointer-events-none"
    :class="[
      variant === 'primary' &&
        `text-blue-500 outline-blue-500 hover:bg-blue-100 dark:hover:bg-blue-900/50`,
      variant === 'danger' &&
        `text-red-500 outline-red-500 hover:bg-red-100 dark:hover:bg-red-900/30`,
    ]"
  >
    <slot v-if="$slots.icon" name="icon" />
    <component
      :is="iconMappingMicro[props.icon]"
      v-else-if="props.icon"
      class="size-4"
    />

    <span class="mr-0.5 empty:hidden">
      <slot></slot>
    </span>
  </button>
</template>

<script setup lang="ts">
import {
  type MappedIconMicro,
  iconMappingMicro,
} from "@/icons/icon-mapping-micro";

defineSlots<{
  default(): unknown;
  icon?(): unknown;
}>();

const props = withDefaults(
  defineProps<{
    icon?: MappedIconMicro;
    variant?: "primary" | "danger";
    disabled?: boolean;
  }>(),
  {
    variant: "primary",
  }
);
</script>
